<template>
  <div>
    <mdb-row>
      <mdb-col md="4" style="margin-bottom: 10px;">
        <div class="form__group">
          <div class="form__group">
            <label for="childEmerFirstName" class="form__label">Nombre(s):</label>
            <input
              v-model="childEmerFirstName"
              type="text"
              id="childEmerFirstName"
              class="form__input"
              value
              style="text-transform: capitalize !important;"
            />
            <validation-error :validation="$v.childEmerFirstName" />
          </div>
        </div>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <mdb-col md="4" style="margin-bottom: 10px;">
        <div class="form__group">
          <div class="form__group">
            <label for="childEmerLastName" class="form__label">Apellido Paterno:</label>
            <input
              v-model="childEmerLastName"
              type="text"
              id="childEmerLastName"
              class="form__input"
              value
              style="text-transform: capitalize !important;"
            />
            <validation-error :validation="$v.childEmerLastName" />
          </div>
        </div>
      </mdb-col>

      <mdb-col md="4" style="margin-bottom: 10px;">
        <div class="form__group">
          <div class="form__group">
            <label for="childEmerMotherLastName" class="form__label">Apellido Materno:</label>
            <input
              type="text"
              v-model="childEmerMotherLastName"
              id="childEmerMotherLastName"
              class="form__input"
              value
              style="text-transform: capitalize !important;"
            />
            <validation-error :validation="$v.childEmerMotherLastName" />
          </div>
        </div>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <mdb-col md="4" sm="8" sx="12" style="margin-bottom: 10px;">
        <div class="form__group">
          <label for="childEmerRelationship" class="form__label">Parentesco:</label>
          <select v-model="childEmerRelationship" class="browser-default custom-select">
            <option selected>Selecciona una opción</option>
            <option value="Madre">Madre</option>
            <option value="Padre">Padre</option>
            <option value="Herman@">Herman@</option>
            <option value="Hij@">Hij@</option>
            <option value="Ti@">Ti@</option>
          </select>
          <validation-error :validation="$v.childEmerRelationship" />
        </div>
      </mdb-col>

      <mdb-col lg="4" md="8" sm="12" style="margin-bottom: 10px;">
        <div class="form__group">
          <label class="form__label" for="childEmerPhone">Teléfono Celuar:</label>
          <input
            type="text"
            v-model="childEmerPhone"
            placeholder="(+52)"
            id="childEmerPhone"
            class="form__input"
            v-mask="'##########'"
          />
          <validation-error :validation="$v.childEmerPhone" />
        </div>
      </mdb-col>
    </mdb-row>
  </div>
</template>
<script>
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import { mdbRow, mdbCol } from "mdbvue";
import ValidationError from "../misc/ValidationError";
import {
  required,
  email,
  minLength,
  alphaNum,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";
import { mask } from "vue-the-mask";

export default {
  name: "childEmergencyContact",
  props: ["index"],
  components: {
    mdbRow,
    mdbCol,
    ValidationError,
  },
  directives: { mask },
  data() {
    return {
      childEmerFirstName: "",
      childEmerLastName: "",
      childEmerMotherLastName: "",
      childEmerRelationship: "",
      childEmerPhone: "",
      childrens: [],
    };
  },
  validations: {
    childEmerFirstName: {
      required,
    },
    childEmerLastName: {
      required,
    },
    childEmerMotherLastName: {
      required,
    },
    childEmerRelationship: {
      required,
    },
    childEmerPhone: {
      required,
    },
  },
  mounted() {
    this.childrens = this.beneficiaries.filter(function (item) {
      return item.beneficiaryType != "SPOUSE";
    });


    if (this.childrens.length > 0) {
      this.getChildInfo(this.childrens[this.index]);
    }
  },
  methods: {
    getChildInfo(child) {
      var phone = child.phones.filter(function (item) {
        return item.phoneType == "Emergency";
      });


      if(phone.length>0){
          this.childEmerFirstName = phone[0].contactName.split(" ")[0]
         
      this.childEmerLastName= phone[0].contactName.split(" ")[1]
      this.childEmerMotherLastName= phone[0].contactName.split(" ")[2]
      this.childEmerRelationship= phone[0].contactRelationship
      this.childEmerPhone= phone[0].phoneNumber

      }

    },

    getFormdata() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return false;
      } else {
        let phoneList = {
          phone: this.childEmerPhone,
          contactName:
            this.childEmerFirstName +
            " " +
            this.childEmerLastName +
            " " +
            this.childEmerMotherLastName,
          contactRelationship: this.childEmerRelationship,
          phoneType: "Emergency",
        };

        return phoneList;
      }
    },
  },
  computed: {
       ...mapGetters({
      beneficiaries: "getBeneficiariesData"
    }),

  }

};
</script>